module.exports = __webpack_public_path__ + "img/bg_money.c5892c8b.svg";